var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[(_vm.isAdmin)?_c('Administrator'):_c('Client')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }